import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import RecoveryCodes from './two-step-verification/RecoveryCodes'
import TwostepVerification from './two-step-verification/TwostepVerification'
import { useTranslation } from 'react-i18next'
import { fetchCsrfCookie } from '../../../redux/action/csrf/csrf-cookie'
import { useDispatch } from 'react-redux'
import { Button, Form, Modal } from 'react-bootstrap'

const UserForm = () => {
    const [btnLoading, setBtnLoading] = useState(false)
    const {t} = useTranslation();
    const two_factor = localStorage.getItem("two_factor")
    const [show, setShow] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState('')
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showData, setShowData] = useState(false)
    const [isActive, setIsactive] = useState(two_factor)
    let dispatch = useDispatch()

    const handleClose = () => {
        setShow(false)
    };

    const handleConfirmPass = (e) => {
        setConfirmPassword(e.target.value)
    }

    useEffect(() => {
        setIsactive(two_factor)
    }, [isActive])

    const handleCheckPassword = (e) => {
        e.preventDefault()
        dispatch(fetchCsrfCookie())
        setBtnLoading(true)
        toast.info(t("toast_check_info") , {position: 'bottom-right',className: 'foo-bar'})
        axios.post('user/confirm-password', {password:confirmPassword } ,{withCredentials: true})
        .then(res => {
            axios.delete('user/two-factor-authentication')
            .then(res => {
                setBtnLoading(false)
                setConfirmPassword('')
                localStorage.setItem("two_factor", "false")
                setIsactive(false)
                toast.dismiss()
                toast.success(t("toast_twofactor_deactived") , {position: 'bottom-right',className: 'foo-bar'})
            })
            .catch(err => {
                setBtnLoading(false)
                console.log(err)
            })
            setShow(false)
        })
        .catch(err => {
            setBtnLoading(false)
            if(err.message === "Request failed with status code 422") {
                toast.dismiss()
                toast.error(t("toast_password_not_correct") , {position: 'bottom-right',className: 'foo-bar'})
            }
        })
    }

    const ActiveTwostepVerification = () => {
        dispatch(fetchCsrfCookie())
        setBtnLoading(true)
        axios.post('user/two-factor-authentication')
        .then(res => {
            setBtnLoading(false)
            localStorage.setItem("two_factor", "true")
            setShowData(true)
            setIsactive('true')
        })
        .catch(err => {
            setBtnLoading(false)
            if(err.response.status === 423) {
                setShowConfirmModal(true)
            } 
        })
    }

    const DeactiveTwostepVerification = (e) => {
        setShow(true)
    }

    const update = () => {
        localStorage.setItem("two_factor", "true")
        setIsactive('true')
    }

    return (
        <div className='userform'>
            <div className='userform_item'>
                 <span>{t("two-step-verification-code")}:</span>
                 <div>
                    {isActive === 'true' ?
                        <div className='two-step'><span>{t("active_twostep")} </span><button className='btn btn-outline-danger' onClick={DeactiveTwostepVerification} disabled={btnLoading ? true : false} >{t("deactivation")}</button></div>
                    :   <div className='two-step'><span>{t("deactive_twostep")}</span><button className='btn btn-outline-success' onClick={ActiveTwostepVerification} disabled={btnLoading ? true : false} >{t("activation")}</button></div>
                    }
                 </div>
            </div>
            {showConfirmModal && <TwostepVerification update={update} />}
            {showData && <RecoveryCodes />}

            {
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                    <Modal.Title style={{fontSize: '1.1rem'}}>{t("activate_twostep")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("To disable two-step login, please enter your password")}</p>
                        <Form onSubmit={e => handleCheckPassword(e)}>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Control value={confirmPassword} name="confirmPassword" onChange={e => handleConfirmPass(e)} type="password" />
                            </Form.Group>
                            <Button variant="primary" type="submit" disabled={btnLoading ? true : false}>
                                {t("confirm")} 
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            }
        </div>
    )
}

export default UserForm
